let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("769Yy")).then(() => parcelRequire('2gy6A'));